import { ImageType } from '@inter-ikea-storageone/range';
import { GalleryConfig } from 'rangeConfig/@types';

const kallaxGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-59560674' },
        { id: 'SPR-59552914' },
        { id: 'SPR-49278256' },
        { id: 'SPR-49579971' },
        { id: 'SPR-59278265' },
        { id: 'SPR-39552910' },
        { id: 'SPR-39278290' },
        { id: 'SPR-29552915' },
        { id: 'SPR-59278307', image: { index: 1, type: ImageType.CPP } },
        { id: 'SPR-19197596' },
        { id: 'SPR-79552951' },
        { id: 'SPR-89278259' }
      ]
    }
  ]
};

export default kallaxGalleryConfig;
